













































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Swipe, SwipeItem, Button, Uploader, Overlay } from "vant";
import {
  driverOcr,
  advertisement,
  getUserInfo,
  producpe,
} from "@/api/api.config";
import { Dialog } from "vant";
import { insertMation, getorders } from "@/api/api.config";
// import { __vlsRenderHelper } from "../../../../vue-temp/vue-editor-bridge";
Component.registerHooks(['beforeRouteEnter'])

interface Parms {
  [key: string]: any
}

Vue.use(Button)

Vue.use(Overlay)

Vue.use(Uploader)

Vue.use(Swipe)
Vue.use(SwipeItem)

@Component
export default class Index extends Vue {
  activedId: any = "";
  checked = false;
  hidden: Boolean = false;
  authChecked = false;
  vinInfo: Parms = {};
  showVINPopup = false;
  lists: any = {};
  showTitle: boolean = false;
  carvin = "";
  vinImg = "";
  isShowVIN = false;
  signatureImg: any = "";
  enterpriseName: any = "";
  banner: any[] = [];
  footerBanner: any[] = [];
  product: any = {
    connectName: '',
    connectNumber: '',
    carTypeId: '',
    reserveTime: '',
    productIds: [],
    productNames: [],
    enterpriseId: '',
    sign: '',
  }
  id: any = ''
  prodype: any = ''
  beforeUpdate() {
    this.product = this.$route.query.product
    this.prodype = this.$route.query.prodype
  }

  created() {
    this.advertisement({ location: '1' }).then((data) => {
      this.banner = data
    })
    this.advertisement({ location: '2' }).then((data) => {
      this.footerBanner = data
    })
    this.product = this.$route.query.product
    console.log(this.product, '测试9999999999999999')

    this.prodype = this.$route.query.prodype
    this.enterpriseName = this.$route.query.enterpriseName

    this.getUserInfo()
    this.activedId = this.$route.query.id
  }

  beforeRouteEnter(to: any, from: any, next: any) {
    let sign = localStorage.getItem('signatureImg')
    let route = ['Signature', 'Example', 'Guide', 'Agreement']
    next((vm: any) => {
      vm.signatureImg = sign
      if (!route.toString().includes(from.name)) {
        vm.signatureImg = ''
        vm.checked = false
        vm.authChecked = false
        vm.vinInfo = {}
        vm.vinImg = ''
      }
    })
  }

  getUserInfo() {
    getUserInfo().then((data: any) => {
      localStorage.setItem('companyName', data.companyName)
    })
  }

  advertisement(parms?: any) {
    return advertisement(parms).then(({ data }: any) => {
      return Promise.resolve(data)
    })
  }

  afterRead(flie: any) {
    this.show('识别中')
    const param = new FormData()
    param.append('file', flie.file)
    param.append('bucket', 'car-report')
    driverOcr(param)
      .then(({ data }: any) => {
        const { retcode, carvin, digits } = data
        if (retcode == '2') {
          this.toast('图片识别有误，请重新拍照上传。')
        } else if (retcode == '0') {
          this.toast('请上传正确的图片格式。')
        } else if (digits < 8) {
          Dialog.confirm({
            message: '此车可能为非新能源汽车，继续查询将失败',
          })
            .then(() => {
              this.showVINPopup = true
              this.vinInfo = data
              this.vinImg = this.vinInfo.cardstr

              this.carvin = carvin
              localStorage.setItem('OWNER', 'owner')
            })
            .catch(() => {
              this.toast('已取消')
            })
        } else {
          this.showVINPopup = true
          this.vinInfo = data
          this.vinImg = this.vinInfo.cardstr
          this.carvin = carvin
          localStorage.setItem('OWNER', 'owner')
        }
        this.hide()
      })
      .catch((err) => {
        if (err.response.status === 413) this.toast('图片太大,请重新上传')
        this.hide()
      })
  }

  onOversize() {
    this.toast('图片大小不能超过5M')
  }

  compare(x: any, y: any) {
    var z = 0
    if (typeof x == 'string') {
      x = x.split('')
      y = y.split('')
    }

    var a = x.shift()
    var b = y.shift()
    while (a !== undefined && b !== undefined) {
      if (a === b) {
        a = x.shift()
        b = y.shift()
      } else {
        z++
        a = x.shift()
        b = y.shift()
      }
    }
    return z
  }

  confirmVIN() {
    let int = this.compare(this.carvin, this.vinInfo.carvin)
    if (int >= 4) {
      this.toast('只能修改3个字符')
      return
    }
    if (this.carvin.length != 17) {
      this.toast('VIN码长度不正确')
      return
    }
    this.showVINPopup = false
    this.isShowVIN = true
    this.toast('上传成功')
  }

  goGuide() {
    this.$router.push({ name: 'Guide' })
  }

  authChange() {
    if (this.authChecked) {
      this.toAuth(3)
    }
  }

  toAuth(type: any) {
    if (type == 2) {
      this.$router.push({
        path: '/signature',
        query: { type: type, id: this.$route.query.id },
      })
    } else if (type == 1) {
      this.$router.push({
        path: '/agreement',
        query: { type: type, id: this.$route.query.id },
      })
    } else if (type == 3) {
      if (!this.vinImg) {
        return
      }
      if (!this.authChecked) {
        this.toast('请确认是车主本人或经过车主授权使用该服务，并完成电子签名')
        return
      }
      this.product = {
        ...this.product,
        enterpriseName: this.enterpriseName,
        prodype: this.prodype,
        vin: this.carvin,
        drivingLicenseImg: this.vinInfo.cardstr,
        sign: this.signatureImg,
        dcardno: this.vinInfo.dcardno,
      }
      this.$router.push({
        path: '/signature',
        query: {
          id: this.$route.query.id,
          product: this.product,
        },
      })
    }
  }

  submit() {
    if (!this.vinImg) {
      this.toast('请上传行驶证正本照片并核对车架号信息，如有误可修改三位')
      return
    }
    if (!this.checked) {
      this.toast('请查看并同意《用户服务协议》')
      return
    }
    if (!this.signatureImg) {
      if (this.authChecked) {
        this.toast('请重新确认经过车主授权并完成电子签名')
        return
      } else {
        this.toast('请确认是车主本人或经过车主授权使用该服务，并完成电子签名')
        return
      }
    }
    if (this.carvin.length == 17) {
      this.getCarInfo()
    } else {
      this.toast('请输入正确的VIN码')
    }
  }

  getCarInfo() {
    this.insertList()
  }

  insertList() {
    insertMation(this.product).then((res) => {
      if (res.data.code === '0') {
        this.$toast.success('预约成功')
        this.$router.push({
          name: 'Success',
          query: {
            enterpriseName: this.enterpriseName,
            reserveTime: this.product.reserveTime,
          },
        })
        this.carvin = ''
        this.signatureImg = ''
      } else {
        this.$toast.fail(res.data.message)
        setTimeout(() => {
          this.$router.push({
            name: 'Home',
          })
          sessionStorage.removeItem('pinpai')
          this.carvin = ''
          this.signatureImg = ''
          this.vinImg = ''
        }, 2000)
      }
    })
  }

  activated() {
    this.activedId = this.$route.query.id
    // console.log( ,'刚刚打印')
    if (this.activedId == 1) {
      document.title = "车辆历史报告";
    } else if (this.activedId == 2) {
      document.title = "线上检测";
    }
    if (this.$route.query.id) {
      this.producpeList(this.activedId)
    }
    if (this.$route.query.signatureImg) {
      this.product.sign = this.$route.query.signatureImg
    }
  }

  toSearch() {
    console.log(typeof Number(this.vinInfo.dcardno))
    if (this.vinInfo.cardstr && this.vinInfo.carvin && this.signatureImg) {
      getorders({
        drivingLicenseImg: this.vinInfo.cardstr,
        vin: this.vinInfo.carvin,
        dcardno: Number(this.vinInfo.dcardno),
        sign: this.signatureImg,
        productId: this.lists.productId,
        productName: this.lists.productName,
      }).then((res) => {
        if (res.data.code == '0') {
          this.$router.push({
            path: '/order',
            query: {
              list: JSON.stringify({
                ...this.lists,
                drivingLicenseImg: this.vinInfo.cardstr,
                vin: this.vinInfo.carvin,
                sign: this.signatureImg,
                orderId: res.data.data,
                dcardno: Number(this.vinInfo.dcardno),
              }),
            },
          })
        } else {
          this.$toast.fail('获取订单号失败')
        }
      })
    } else {
      this.$toast.fail('请满足条件')
    }
  }

  toesearch() {
    this.$router.push({
      name: 'Home',
    })
  }

  clreport(index: any) {
    console.log(index, "缓存值");
    if (index == 1) {
      document.title = "车辆历史报告";
    } else if (index == 2) {
      // document.title = '线上检测'
      // this.showTitle = true
      // this.$dialog
      //   .alert({
      //     title: '提示',
      //     message: '系统升级维护中,暂不支持该功能 !',
      //   })
      //   .then(() => {
      //     this.showTitle = false
      //   })
      // return
    }
    this.$router.push({
      path: '/index',
      query: { id: index },
    })
    this.producpeList(index)
  }
  producpeList(index: any) {
    producpe(index).then((res) => {
      this.lists = res.data.data
    })
  }
}
